import { fetchEventDates } from './eventDatesActions'
import prepareFilter from '../helpers/filter/prepare'

const saveFilter = (store, filter) => {
    const { settings } = store.getState()

    store.setState({
        settings: {
            ...settings,
            filter
        }
    })
}

export const changeFilter = (store, filterChanges) => {
    const previousFilter = store.getState().settings.filter
    const nextFilter = prepareFilter(previousFilter, filterChanges)

    if (nextFilter) {
        saveFilter(store, nextFilter)
    }
}

export const changeFilterAndFetch = (store, filterChanges) => {
    const previousFilter = store.getState().settings.filter
    const nextFilter = prepareFilter(previousFilter, filterChanges)

    if (nextFilter !== null) {
        nextFilter.type = null

        saveFilter(store, nextFilter)
        fetchEventDates(store)
    }
}

export const changeShowAdvancedFilter = (store, show) => {
    return { showAdvancedFilter: show }
}

export const changeShowMobileFilter = (store, show) => {
    return { showMobileFilter: show }
}
